export enum EnumCardTemplate {
  "basic" = "basic",
}
